class StickyProVariantSelect extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onStickyVariantChange);
  }

  onStickyVariantChange() {
    if (document.getElementById(`product-form-${this.dataset.section}`)?.dataset.hdProductInfoPending === "true") return;
    this.varOptions = this.querySelector("select");
    if (!this.varOptions) return;

    let productForms = document.querySelector(
      `#product-sticky-form-${this.dataset.section}`
    );
    if (!productForms) return;

    let input = productForms.querySelector('input[name="id"]');
    if (input) input.value = this.varOptions.value;

    // HEDERA — تحديث نص الزر وحالة التعطيل حسب الـVariant المحدد
    const option = this.varOptions.options[this.varOptions.selectedIndex];
    if (option) hederaUpdateStickyButton(productForms, option.dataset.hdState);
  }
}
customElements.define("sticky-variant-select", StickyProVariantSelect);

/*
  HEDERA — الحالات الثلاث داخل شريط الشراء الثابت.
  الحالة تصل من data-hd-state على <option>، وهي مُولَّدة في Liquid من
  snippets/hedera-stock-state.liquid، فلا يوجد منطق مخزون مكرر في JavaScript.
*/
function hederaUpdateStickyButton(form, state) {
  if (!form || !window.variantStrings) return;
  const addButton =
    form.querySelector("[data-hd-sticky-add]") || form.querySelector('[name="add"]');
  if (!addButton) return;

  if (typeof window.hederaSyncPreorderProperty === "function") {
    window.hederaSyncPreorderProperty(form, state);
  }

  if (state === "unavailable") {
    addButton.setAttribute("disabled", "disabled");
    addButton.textContent = window.variantStrings.soldOut;
  } else if (state === "preorder") {
    addButton.removeAttribute("disabled");
    addButton.textContent = window.variantStrings.preorder;
  } else if (state === "available") {
    addButton.removeAttribute("disabled");
    addButton.textContent = window.variantStrings.addToCart;
  }
}

/*
  HEDERA — مزامنة الشريط الثابت مع محدد الخيارات الرئيسي في صفحة المنتج.
  Listener واحد فقط على حدث مخصص يبثّه product-variant.js.
  Quick View له صنف مستقل ولا يبثّ هذا الحدث، فلا يتأثر.

  V1.1.1:
  - التحديد يتم عبر event.detail.sectionId حصراً (لا معرّفات ثابتة على
    مستوى الصفحة)، فحدث صادر من قسم آخر لا يمسّ شريط هذا القسم.
  - عند id: null (تركيبة خيارات غير موجودة) يُفرَّغ حقل الـVariant المخفي،
    يُعطَّل الزر، ويُعرض نص variantStrings.unavailable — نفس النص الذي
    يعرضه setUnavailable() على الزر الرئيسي في product-variant.js، وهو
    متعمَّد مختلف عن variantStrings.soldOut الخاص بحالة "unavailable"
    العادية (Variant حقيقي غير متوفر) حتى لا يلتبس السببان.
  - لا حساب حالة مخزون هنا: المسار الطبيعي ما زال يعتمد فقط على
    data-hd-state القادم من Liquid عبر hederaUpdateStickyButton().
*/
document.addEventListener("hedera:variant:changed", function (event) {
  const detail = (event && event.detail) || {};
  const sectionId = detail.sectionId;
  if (!sectionId) return;

  const stickyForm = document.getElementById(
    "product-sticky-form-" + sectionId
  );
  if (!stickyForm) return; // لا يوجد شريط ثابت لهذا القسم في هذه الصفحة

  const stickyInput = stickyForm.querySelector('input[name="id"]');
  const addButton =
    stickyForm.querySelector("[data-hd-sticky-add]") ||
    stickyForm.querySelector('[name="add"]');

  const pendingSelect = document.querySelector('select[form="' + stickyForm.getAttribute('id') + '"]');
  if (detail.state === "pending") {
    if (stickyInput) stickyInput.value = "";
    window.hederaVariantState.begin(stickyForm);
    if (pendingSelect && !pendingSelect.disabled) {
      pendingSelect.dataset.hdPendingDisabled = "true";
      pendingSelect.disabled = true;
    }
    return;
  }
  window.hederaVariantState.end(stickyForm);
  if (pendingSelect?.dataset.hdPendingDisabled) {
    pendingSelect.disabled = false;
    delete pendingSelect.dataset.hdPendingDisabled;
  }

  if (detail.id == null) {
    // HEDERA — تركيبة غير موجودة: تفريغ الحقل ومنع إرسال Variant قديم.
    if (stickyInput) stickyInput.value = "";
    if (typeof window.hederaSyncPreorderProperty === "function") {
      window.hederaSyncPreorderProperty(stickyForm, "unavailable");
    }
    if (addButton && window.variantStrings) {
      addButton.setAttribute("disabled", "disabled");
      addButton.textContent = window.variantStrings.unavailable;
    }
    return;
  }

  if (stickyInput) stickyInput.value = detail.id;

  const stickySelect = document.querySelector(
    'select[form="' + stickyForm.getAttribute('id') + '"]'
  );
  if (!stickySelect) return; // منتج بلا خيارات: لا قائمة اختيار في الشريط الثابت

  const option = stickySelect.querySelector(
    'option[value="' + detail.id + '"]'
  );
  if (!option) return;

  stickySelect.value = option.value;
  hederaUpdateStickyButton(stickyForm, option.dataset.hdState);
});

/*
  HEDERA — حارس إرسال: يمنع إرسال أي نموذج شراء ثابت بحقل Variant فارغ
  (الحالة التي يتركها حدث id: null أعلاه)، حتى لو أُرسل النموذج بغير
  الضغط المباشر على الزر المعطَّل.
*/
document
  .querySelectorAll('form[id^="product-sticky-form-"]')
  .forEach(function (form) {
    form.addEventListener("submit", function (event) {
      const idInput = form.querySelector('input[name="id"]');
      if (!idInput || !idInput.value) event.preventDefault();
    });
  });

let stickySelectedVariant = document.querySelector(`#sticky__variant`);
if (stickySelectedVariant) {
  let stickySelectVairantInput = document.querySelector(
    "#sticky__selected_variant_id"
  );
  if (stickySelectVairantInput) {
    stickySelectVairantInput.value = stickySelectedVariant.value;
  }
}

const BuyButtonForm = document.querySelector(".product_buy_button_form");
const productStickyWrapper = document.querySelector(".product__sticky");

/*
  HEDERA v1.3.1 (Task 4B) — توقيت ظهور الشريط الثابت.
  حارس أولي: صفحة بلا شريط ثابت (productStickyWrapper) أو بلا نموذج شراء
  أصلي (BuyButtonForm) لا تُسجَّل لها أي Listeners إطلاقًا، فلا خطأ يُرمى.

  الديسكتوب: نفس منطق ما قبل v1.3.1 حرفيًا (سكرول متجاوز لأعلى نموذج الشراء
  الأصلي) — بلا أي تغيير في السلوك أو التوقيت.

  الهاتف (حتى 749px) فقط: IntersectionObserver على عنصرين بلا Listener
  مكرر على scroll — يظهر الشريط بعد تجاوز معرض الصور نزولًا، يختفي أثناء
  ظهور الأزرار الأصلية، ويعاود الظهور بعد تجاوزها. لا يظهر أبدًا فوق
  المعرض عند أول تحميل (الحالة الابتدائية لِـIntersectionObserver تعكس ذلك
  تلقائيًا). لا تعديل على مزامنة الـVariant/الكمية/القوائم في هذا الملف.
*/
if (productStickyWrapper && BuyButtonForm) {
  const hdIsMobileSticky = window.matchMedia("(max-width: 749px)").matches;

  if (!hdIsMobileSticky || !("IntersectionObserver" in window)) {
    window.addEventListener("scroll", function () {
      let BuyBUttonOffset = TopOffset(BuyButtonForm);
      let BuyBUttonTopffset = BuyBUttonOffset.top;

      if (window.scrollY > BuyBUttonTopffset) {
        productStickyWrapper.classList.add("sticky");
        document.body.classList.add("sticky__cart");
      } else {
        productStickyWrapper.classList.remove("sticky");
        document.body.classList.remove("sticky__cart");
      }
    });
  } else {
    const hdGalleryEl = document.querySelector(".product__media_container");
    let hdGalleryPassed = !hdGalleryEl;
    let hdButtonsVisible = false;

    function hdUpdateMobileSticky() {
      const shouldShow = hdGalleryPassed && !hdButtonsVisible;
      productStickyWrapper.classList.toggle("sticky", shouldShow);
      document.body.classList.toggle("sticky__cart", shouldShow);
    }

    if (hdGalleryEl) {
      new IntersectionObserver(function (entries) {
        hdGalleryPassed = !entries[0].isIntersecting;
        hdUpdateMobileSticky();
      }).observe(hdGalleryEl);
    }

    new IntersectionObserver(function (entries) {
      hdButtonsVisible = entries[0].isIntersecting;
      hdUpdateMobileSticky();
    }).observe(BuyButtonForm);
  }
}
